<template>
  <div>
    <div class="card card-custom gutter-b" style="box-shadow: none">
      <div class="card-header card-header-tabs-line">
        <ul
          class="nav nav-dark nav-bold nav-tabs nav-tabs-line"
          role="tablist"
          ref="builder-tab"
        >
          <li class="nav-item">
            <a
              class="nav-link active"
              data-tab="0"
              data-toggle="tab"
              href="#"
              role="tab"
            >
              Cadastro
            </a>
          </li>
        </ul>
      </div>

      <b-form class="form" @submit.stop.prevent="onSubmit">
        <div class="card-body">
          <b-tabs class="hide-tabs" v-model="tabIndex">
            <b-tab active>
              <b-row>
                <b-col md="4">
                  <b-form-group
                    :class="{ 'required-field': !form.ambiente_id }"
                    id="ambiente_id"
                    label-for="ambiente_id"
                    label="Ambiente"
                  >
                    <b-form-select
                      v-model="$v.form.ambiente_id.$model"
                      :state="validateState('ambiente_id')"
                      :options="ambienteOptions"
                    />
                  </b-form-group>
                </b-col>
                <b-col v-if="!isCreateMode" md="2">
                  <b-form-group
                    :class="{ 'required-field': !form.numero }"
                    id="numero"
                    label-for="numero"
                    label="Número"
                  >
                    <b-form-input
                      v-model="$v.form.numero.$model"
                      :state="validateState('numero')"
                      maxlength="20"
                      autofocus
                    />
                  </b-form-group>
                </b-col>
                <b-col v-if="isCreateMode" md="2">
                  <b-form-group
                    :class="{
                      'required-field': isEmptyValue(form.numero_inicial),
                    }"
                    id="numero_inicial"
                    label-for="numero_inicial"
                    label="Número inicial"
                  >
                    <b-form-input
                      v-model="$v.form.numero_inicial.$model"
                      :state="validateState('numero_inicial')"
                      type="number"
                      min="0"
                      autofocus
                    />
                  </b-form-group>
                </b-col>
                <b-col v-if="isCreateMode" md="2">
                  <b-form-group
                    :class="{
                      'required-field': isEmptyValue(form.numero_final),
                    }"
                    id="numero_final"
                    label-for="numero_final"
                    label="Número final"
                  >
                    <b-form-input
                      v-model="$v.form.numero_final.$model"
                      :state="validateState('numero_final')"
                      type="number"
                      min="0"
                    />
                  </b-form-group>
                </b-col>
                <b-col :md="isCreateMode ? 3 : 4">
                  <b-form-group id="nome" label-for="nome" label="Nome">
                    <b-form-input v-model="form.nome" maxlength="100" />
                  </b-form-group>
                </b-col>
                <b-col :md="isCreateMode ? 1 : 2">
                  <b-form-group id="ativo" label-for="ativo" label="Ativo">
                    <span class="switch switch-icon">
                      <label>
                        <input
                          type="checkbox"
                          :checked="form.ativo == true"
                          @change="setAtivo"
                        />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="3">
                  <b-form-group
                    id="capacidade"
                    label-for="capacidade"
                    label="Capacidade"
                  >
                    <b-form-input
                      v-model="$v.form.capacidade.$model"
                      :state="validateState('capacidade')"
                      type="number"
                      min="0"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group id="status" label-for="status" label="Status">
                    <b-form-select
                      v-model="$v.form.status.$model"
                      :state="validateState('status')"
                      :options="statusOptions"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    id="descricao"
                    label-for="descricao"
                    label="Descrição"
                  >
                    <b-form-textarea
                      v-model="form.descricao"
                      rows="3"
                      max-rows="6"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>

        <div class="card-footer">
          <div class="row">
            <div class="col-lg-12" style="text-align: center">
              <button
                type="submit"
                ref="submit_mesa"
                class="btn btn-primary font-weight-bold"
              >
                Salvar
              </button>
              <router-link
                class="btn btn-clean font-weight-bold"
                :to="voltarRoute"
              >
                Cancelar
              </router-link>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
import { MesaDataCreateRequired, MesaDataUpdateRequired } from "./MesaData";
import MesaData from "./MesaData";

export default {
  name: "app-restaurante-mesa-form",
  props: {
    url: {
      type: String,
      required: true,
    },
    mesa: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [validationMixin],
  data() {
    return {
      tabIndex: 0,
      form: new MesaData({}),
      ambienteOptions: [{ value: null, text: "Selecione" }],
      statusOptions: [
        { value: "livre", text: "Livre" },
        { value: "ocupada", text: "Ocupada" },
        { value: "reservada", text: "Reservada" },
        { value: "inativa", text: "Inativa" },
      ],
    };
  },
  validations() {
    return {
      form: this.isCreateMode ? MesaDataCreateRequired : MesaDataUpdateRequired,
    };
  },
  watch: {
    mesa: {
      handler(newValue) {
        this.form = new MesaData(newValue || {});
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
    routeAmbienteId() {
      return this.$route.query.ambiente_id || this.$route.params.ambienteId;
    },
    isCreateMode() {
      return !this.form.id;
    },
    voltarRoute() {
      if (!this.routeAmbienteId) {
        return { name: "restauranteMesasCadastro" };
      }

      return {
        name: "restauranteAmbientesMesas",
        params: {
          ambienteId: this.routeAmbienteId,
        },
        query: {
          ambiente_nome: this.$route.query.ambiente_nome,
        },
      };
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getAmbientes();
  },
  methods: {
    async getAmbientes() {
      try {
        const { data } = await this.$http.post("/restaurante/ambientes/select");
        this.ambienteOptions = [
          { value: null, text: "Selecione" },
          ...data.map((ambiente) => ({
            value: ambiente.id,
            text: ambiente.nome,
          })),
        ];

        if (this.routeAmbienteId && !this.form.ambiente_id) {
          this.form.ambiente_id = parseInt(this.routeAmbienteId, 10);
        }
      } catch (error) {
        this.$toast.error("Não foi possível carregar os ambientes.");
      }
    },
    setAtivo() {
      this.form.ativo = this.form.ativo == true ? false : true;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    isEmptyValue(value) {
      return value === null || value === undefined || value === "";
    },
    setSubmitLoading(isLoading) {
      const submitButton = this.$refs["submit_mesa"];

      if (!submitButton) {
        return;
      }

      if (isLoading) {
        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");
        return;
      }

      submitButton.classList.remove(
        "spinner",
        "spinner-light",
        "spinner-right"
      );
      submitButton.removeAttribute("disabled", "");
    },
    getPayload() {
      const payload = { ...this.form };

      payload.capacidade =
        payload.capacidade === "" || payload.capacidade === null
          ? null
          : parseInt(payload.capacidade, 10);

      if (this.isCreateMode) {
        payload.numero_inicial = parseInt(payload.numero_inicial, 10);
        payload.numero_final = parseInt(payload.numero_final, 10);
        delete payload.numero;
      } else {
        delete payload.numero_inicial;
        delete payload.numero_final;
      }

      return payload;
    },
    async onSubmit() {
      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        this.setSubmitLoading(true);
        await this.$http.post(this.url, this.getPayload());
        this.$router.push(this.voltarRoute);
      } catch (error) {
        this.setSubmitLoading(false);
      }
    },
  },
};
</script>
